<template>
  <v-form ref="p1Form" v-model="p1Form" lazy-validation>
    <v-container>
      <v-card elevation="5" title="入力フォームサンプル">
        <v-row>
          <v-col>
            <ryou-input
              v-model="input1"
              :value="input1"
              :label="'入力'"
              :rules="inputRules"
              :maxlength="20"
            ></ryou-input>
          </v-col>
          <v-col>
            <ryou-date
              v-model="date1"
              :value="date1"
              :rules="dateRules"
            ></ryou-date>
          </v-col>
          <v-col>
            <ryou-radio
              v-model="radio1"
              :value="radio1"
              :items="radioItems"
              :rules="dateRules"
            ></ryou-radio>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="4">
            <ryou-textarea
              v-model="textarea1"
              :value="textarea1"
              :label="'テキストエリア'"
              :rules="requiredRules"
            ></ryou-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ryou-checkbox
              v-model="checkbox1"
              :value="checkbox1"
              :label="'チェックボックス'"
              :rules="requiredRules"
            ></ryou-checkbox>
          </v-col>
          <v-col>
            <ryou-combobox
              v-model="combobox1"
              :value="combobox1"
              :label="'コンポボックス'"
              :items="items"
              :rules="requiredRules"
            ></ryou-combobox>
          </v-col>
          <v-col>
            <ryou-select
              v-model="select1"
              :value="select1"
              :label="'セレクトボックス'"
              :items="items"
              :rules="requiredRules"
            ></ryou-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <ryou-black-btn
              :label="'黒色ボタン'"
              :handlerClick="test"
            ></ryou-black-btn>
          </v-col>
          <v-col>
            <ryou-blue-btn
              :label="'青色ボタン'"
              :handlerClick="test"
            ></ryou-blue-btn>
          </v-col>
          <v-col>
            <ryou-del-btn :handlerClick="test"></ryou-del-btn>
          </v-col>
          <v-col>
            <ryou-add-btn :handlerClick="test"></ryou-add-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card>
        <v-row>
          <v-col :cols="4">
            <v-file-input
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              label="Click here to select a Excel file"
              outlined
              v-model="chosenFile"
            >
            </v-file-input>
          </v-col>
          <v-col :cols="2">
            <ryou-black-btn
              :label="'ファイル入力'"
              :handlerClick="importFile"
            ></ryou-black-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card>
        <v-row>
          <v-col :cols="2">
            <ryou-black-btn
              :label="'Grid-Add-Row'"
              :handlerClick="doGridAddRow"
            ></ryou-black-btn>
          </v-col>
          <v-col :cols="2">
            <ryou-black-btn
              :label="'Batch-Insert'"
              :handlerClick="doGridValidateSubmit"
            ></ryou-black-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-form ref="tableForm" v-model="tableForm" lazy-validation>
        <ryou-table
          ref="ryouEditTable"
          :rowKey="rowKeyEdit"
          :title="'可編集一覧'"
          :headers="headers"
          :editItems="editItems"
          :url="url"
          :showSelect="showSelect"
          :singleSelect="singleSelect"
          :handleEdit="handleEdit"
          :handleDelete="handleDelete"
          :inputRules="inputRules"
          :dummy="true"
        >
        </ryou-table>

        <br />
        <br />
        <br />

        <v-card>
          <v-row>
            <v-col>
              <v-row class="pa-6">
                <ryou-input
                  v-model="queryParam.companyId"
                  :value="queryParam.companyId"
                  :label="'検索_id'"
                  @change="searchQuery"
                ></ryou-input>
              </v-row>
            </v-col>
            <v-col>
              <v-row class="pa-6">
                <ryou-input
                  v-model="queryParam.companyName"
                  :value="queryParam.companyName"
                  :label="'検索_name'"
                  @change="searchQuery"
                ></ryou-input>
              </v-row>
            </v-col>
            <v-col>
              <v-row class="pa-6">
                <ryou-input
                  v-model="queryParam.companyCode"
                  :value="queryParam.companyCode"
                  :label="'検索_code'"
                  @change="searchQuery"
                ></ryou-input>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="2">
              <ryou-black-btn
                :label="'新規'"
                :handlerClick="handleAdd"
              ></ryou-black-btn>
            </v-col>
            <v-col :cols="2">
              <ryou-black-btn
                :label="'Batch-Delete'"
                :handlerClick="batchDel"
              ></ryou-black-btn>
            </v-col>
          </v-row>
        </v-card>
        <ryou-table
          ref="ryouTable"
          :rowKey="rowKey"
          :title="'表示一覧'"
          :headers="headers"
          :queryParams="queryParam"
          :url="url"
          :showSelect="showSelect"
          :singleSelect="singleSelect"
          :handleEdit="handleEdit"
          :handleDelete="handleDelete"
          :uploadFile="uploadFile"
          :inputRules="inputRules"
          :businessKey="businessKey"
          :dummy="false"
          :needSearch="true"
        >
          <v-row slot="filterContainer">
            <v-col cols="4">
              <v-row class="pa-6">
                <ryou-input
                  v-model="idFilterValue"
                  :value="idFilterValue"
                  :label="'フィルタ_id'"
                ></ryou-input>
              </v-row>
            </v-col>
            <v-col cols="4">
              <v-row class="pa-6">
                <ryou-input
                  v-model="nameFilterValue"
                  :value="idFilterValue"
                  :label="'フィルタ_name'"
                ></ryou-input>
              </v-row>
            </v-col>
          </v-row>
        </ryou-table>
      </v-form>
      <master-p1-dialog
        ref="modalForm"
        @ok="modalFormOk"
        :url="url"
      ></master-p1-dialog>
      <ryou-confirm ref="confirm"></ryou-confirm>
    </v-container>
  </v-form>
</template>

<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouDate from "@/components/formInput/RyouDate.vue";
import RyouCheckbox from "@/components/formInput/RyouCheckbox.vue";
import RyouCombobox from "@/components/formInput/RyouCombobox.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouRadio from "@/components/formInput/RyouRadio.vue";
import RyouTextarea from "@/components/formInput/RyouTextarea.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import RyouDelBtn from "@/components/formInput/RyouDelBtn.vue";
import RyouAddBtn from "@/components/formInput/RyouAddBtn.vue";

import RyouTable from "@/components/table/RyouTable.vue";

import MasterP1Dialog from "./modules/MasterP1Dialog.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

import { RyouTableMixins } from "@/mixins/RyouTableMixins";

import { postUploadRequest } from "@/utils/api";

export default {
  name: "MasterSample",
  mixins: [RyouTableMixins],
  components: {
    RyouInput,
    RyouDate,
    RyouCheckbox,
    RyouCombobox,
    RyouSelect,
    RyouRadio,
    RyouTextarea,
    RyouBlackBtn,
    RyouBlueBtn,
    RyouDelBtn,
    RyouAddBtn,
    RyouTable,
    MasterP1Dialog,
    RyouConfirm,
  },
  mounted() {
    this.inputRules.push(this.GlobalRules.required);
    this.inputRules.push(this.GlobalRules.counter_10);

    this.dateRules.push(this.GlobalRules.required);

    this.requiredRules.push(this.GlobalRules.required);
  },
  data() {
    return {
      p1Form: true,
      input1: "aaa",
      date1: new Date().toISOString().substr(0, 10),
      checkbox1: "",
      combobox1: ["テスト１", "テスト４"],
      radio1: "3",
      select1: "テスト１",
      dateVal: "2021-02-02", //new Date().toISOString().substr(0, 10),
      textarea1: "area",
      chosenFile: null,
      idFilterValue: "",
      nameFilterValue: "",
      radioItems: [
        {
          value: "1",
          label: "ラジオ1",
        },
        {
          value: "2",
          label: "ラジオ2",
        },
        {
          value: "3",
          label: "ラジオ3",
        },
      ],
      inputRules: [],
      dateRules: [],
      requiredRules: [],
      input: "",
      email: "",
      checkbox: true,
      items: ["テスト１", "テスト２", "テスト３", "テスト４"],
      select: [],
      items2: ["テスト１", "テスト２", "テスト３", "テスト４"],
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      radioGroup: null,
      search: "",
      rowKey: "rowIndex",
      rowKeyEdit: "rowIndex",
      businessKey: "companyId",
      businessKeys: ["companyId", "companyName"],
      companyId: "",
      companyName: "",
      showSelect: true,
      singleSelect: false,
      tableForm: true,
      headers: [
        {
          text: "#",
          value: "rowIndex",
          // class: "title",
          width: "5%",
          sortable: true,
          groupable: false,
        },
        {
          text: "会社ID",
          value: "companyId",
          class: "lighten-2",
          width: "10%",
          sortable: true,
          groupable: false,
          filter: this.idFilter,
        },
        {
          text: "会社名",
          value: "companyName",
          width: "20%",
          sortable: true,
          groupable: false,
          filter: this.nameFilter,
        },
        {
          text: "会社略称",
          value: "companyCode",
          width: "10%",
          type: "text",
          sortable: true,
          groupable: false,
        },
        {
          text: "日付",
          value: "deadLineDay",
          width: "10%",
          type: "date",
          sortable: true,
          groupable: false,
        },
        {
          text: "ファイル",
          value: "file",
          type: "file",
          // class: "title",
          width: "10%",
          sortable: false,
          groupable: false,
        },
        {
          text: "ボタン",
          value: "btn",
          type: "btn",
          class: "blue lighten-2 title",
          width: "10%",
          sortable: false,
          groupable: false,
        },
        {
          text: "Icon",
          value: "icon",
          type: "icon",
          class: "blue lighten-2 title",
          width: "10%",
          sortable: false,
          groupable: false,
        },
        {
          text: "操作",
          class: "blue lighten-2 title",
          value: "actions",
          align: "center",
          sortable: false,
          groupable: false,
        },
      ],
      editItems: [
        {
          companyId: "",
          companyName: "",
          companyCode: "",
        },
      ],
      height: 300,

      types: ["success", "error", "warning", "info", "default"],

      url: {
        list: "/equipment/getCompany",
        delete: "/equipment/deleteCompany",
        add: "/equipment/addCompany",
        update: "/equipment/updateCompany",
        deleteBatch: "/equipment/deleteBatch",
      },
      // url: {
      //   list: "/company/get",
      //   delete: "/company/delete",
      //   add: "company/insert",
      //   update: "/company/update",
      //   deleteBatch: "/company/deleteBatch"
      // }
    };
  },
  methods: {
    test() {
      var msg = "メッセージ123456";

      this.types.forEach((type) => {
        this.$toast.open({
          message: msg,
          type,
        });
      });

      var valid = this.$refs.p1Form.validate();
      if (valid) {
        // console.log("************");
        // console.log(this.input1);
        // console.log(this.date1);
        // console.log(this.checkbox1);
        // console.log(this.combobox1);
        // console.log(this.select1);
        // console.log(this.textarea1);
        // console.log("************");
      }
    },
    importFile() {
      // var reader = new FileReader();
      let formData = new FormData();
      formData.append("file", this.chosenFile);

      postUploadRequest("/equipment/importTest", formData).then((resp) => {
        debugger;
        if (resp.success) {
          // console.log("scuuess");
        }
      });
    },
    idFilter(value) {
      if (!this.idFilterValue) {
        return true;
      }
      return value.toLowerCase().includes(this.idFilterValue.toLowerCase());
    },
    nameFilter(value) {
      if (!this.nameFilterValue) {
        return true;
      }
      return value.toLowerCase().includes(this.nameFilterValue.toLowerCase());
    },
  },
};
</script>
